<p-dialog
  [(visible)]="displayChildInfoModal"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="displayChildInfoModal = false"
  [style]="{ width: '600px' }"
>
  <div style="padding: 40px 80px">
    <div class="modal__wrapper">
      <div class="modal__title">
        {{ 'EVENT.child_modal.title' | translate }}
      </div>
      <div class="modal__description">
        {{ 'EVENT.child_modal.description_1' | translate }}
      </div>
      <app-ph-input
        class="checkbox"
        type="checkbox"
        [validation]="'checkbox'"
        name="adult"
        (phInputChange)="toogleAdult()"
        [initValue]="false"
      >
        {{ 'EVENT.child_modal.checkbox_1' | translate }}
      </app-ph-input>
      <app-ph-input
        class="checkbox"
        type="checkbox"
        [validation]="'checkbox'"
        name="underage"
        (phInputChange)="toogleUnderageCounter()"
        [initValue]="false"
      >
        {{ 'EVENT.child_modal.checkbox_2' | translate }}
      </app-ph-input>
      <div *ngIf="appendChildren">
        <div class="project-description__participants">
          <app-ph-input
            [placeholder]="'EVENT.child_modal.input' | translate"
            [validation]="'required'"
            type="number"
            name="child_counter"
            [showRequired]="true"
            [correctForm]="correctForm"
            (keyUpEnter)="changeChildInput(currentValueSetChildren)"
            (phInputChange)="saveSetValue($event)"
          ></app-ph-input>
        </div>
      </div>
      <app-ph-input
        class="checkbox"
        type="checkbox"
        [validation]="'checkbox'"
        name="safeByMe"
        (phInputChange)="toogleSafeByMe()"
        [initValue]="false"
      >
        {{ 'EVENT.child_modal.checkbox_3' | translate }}
      </app-ph-input>
      <app-ph-input
        class="checkbox"
        type="checkbox"
        [validation]="'checkbox'"
        name="allowRodo"
        (phInputChange)="toogleAllowRODO()"
        [initValue]="false"
      >
        {{ 'EVENT.child_modal.checkbox_4' | translate }}
      </app-ph-input>
      <app-ph-input
        class="checkbox"
        type="checkbox"
        [validation]="'checkbox'"
        name="AllowPolicy"
        (phInputChange)="toogleAllowPolicy()"
        [initValue]="false"
      >
        {{ 'EVENT.child_modal.checkbox_5' | translate }}
        <a
          class="text--primary-light text-decoration"
          href="https://mcdonalds.pl/ochrona-prywatnosci-przeglad/"
          (click)="$event.stopPropagation()"
          target="_blank"
        >
          https://mcdonalds.pl/ochrona-prywatnosci-przeglad/</a
        >
      </app-ph-input>
      <div class="project-description__content">
        <div class="modal__description">
          {{ 'EVENT.child_modal.description_2' | translate }}
        </div>
        <div class="modal__description">
          {{ 'EVENT.child_modal.description_3' | translate }}
        </div>

        <div class="flex flex-justify-center flex-flow-wrap flex-align-end">
          <button class="btn btn--outline btn--md mt-1 mb-2 mr-2" (click)="closeModal()">
            {{ 'GLOBAL.cancel' | translate }}
          </button>
          <button
            class="btn btn--primary btn--md mt-1 mb-2 ml-2"
            [disabled]="!isActive()"
            (click)="joinWithChildren()"
          >
            {{ 'EVENT.child_modal.i_agree' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
